import { useMutation } from '@tanstack/react-query';
import { emailApiService } from '../services/emailApiService';
import type {
  RequestEmailValidationResponse,
  ValidateEmailResponse,
} from '../types/email';

const RESEND_DELAY = 120;

interface UseEmailValidationReturn {
  requestEmailValidation: () => Promise<RequestEmailValidationResponse>;
  validateEmail: (code: string) => Promise<ValidateEmailResponse>;
  resendDelay: number;
  validateEmailError: Error | null;
  requestEmailValidationError: Error | null;
  isLoading: boolean;
}

export const useEmailValidation = (): UseEmailValidationReturn => {
  const requestEmailValidationMutation = useMutation({
    mutationFn: () => emailApiService.requestEmailValidation(),
  });

  const validateEmailMutation = useMutation({
    mutationFn: (code: string) => emailApiService.validateEmail(code),
  });

  return {
    requestEmailValidation: requestEmailValidationMutation.mutateAsync,
    validateEmail: validateEmailMutation.mutateAsync,
    resendDelay: RESEND_DELAY,
    validateEmailError: validateEmailMutation.error,
    requestEmailValidationError: requestEmailValidationMutation.error,
    isLoading:
      requestEmailValidationMutation.isPending ||
      validateEmailMutation.isPending,
  };
};
